export const parseToUnit = (amount, f = 2, unit = 'Km') => {
  if (!amount && amount !== 0) {
    return ''
  }
  const formattedNumber = `${parseFloat(amount).toFixed(f)} ${unit}`
  return formattedNumber.replace('.', ',')
}
